/**
 * 计划总结api
 */

import { getFetch, postFetch } from '@/plugins/http'
const baseHost = `${process.env.VUE_APP_HOST}/hike-boot`

export default {
  // 计划总结-类型列表
  getPlanSummaryTypeList(params = {}, config) {
    return getFetch(`${baseHost}/common/api/33-type_list/plan_summary`, params, config)
  },
  // 计划总结-列表
  getPlanSummaryList(params = {}, config) {
    return getFetch(`${baseHost}/common/api/34-list/plan_summary`, params, config)
  },
  // 计划总结-保存
  savePlanSummary(params = {}, config) {
    return postFetch(`${baseHost}/common/api/10-save/plan_summary`, params, config)
  },
  // 计划总结-删除
  deletePlanSummary(params = {}, config) {
    return postFetch(`${baseHost}/common/api/90-del/plan_summary`, params, config)
  },
  // 计划总结-详情
  getPlanSummaryDetail(params = {}, config) {
    return getFetch(`${baseHost}/common/api/32-info/plan_summary`, params, config)
  },
  // 获取登录用户归属教研室
  getPlanSummaryUserInfo(params = {}, config) {
    return getFetch(`${baseHost}/common/api/32-default_data/plan_summary`, params, config)
  },
  // 导出计划总结
  downloadPlanSummary(businessType, ids) {
    return `${baseHost}/import/download/downloadPlanSummary?businessType=${businessType}&ids=${ids}`
  }
}
